import { render, staticRenderFns } from "./ContactCard.vue?vue&type=template&id=40573238&scoped=true"
import script from "./ContactCard.vue?vue&type=script&lang=js"
export * from "./ContactCard.vue?vue&type=script&lang=js"
import style0 from "./ContactCard.vue?vue&type=style&index=0&id=40573238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40573238",
  null
  
)

export default component.exports